import ListingPageModal from './listing-page-modal';
export default ListingPageModal;